var map = {
	"./clock-black.svg": "814d",
	"./email-black.svg": "1fba",
	"./event-black.svg": "197b",
	"./mobile-black.svg": "b3d1",
	"./operator-black.svg": "ffa9",
	"./payment-black.svg": "afba",
	"./points-black.svg": "4221",
	"./support-black.svg": "193a",
	"./vehicle-black.svg": "3104"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "85a5";